import grid from './grid.module.css'

export default (items, cssClass, interator) => {
   items = items ? items.split(' ') : []
   let classes = []
   
   if(items[0]) classes.push(grid[`${cssClass}-${items[0]}`])
   if(items[1]) classes.push(grid[`${cssClass}-sm-${items[1]}`])
   if(items[2]) classes.push(grid[`${cssClass}-md-${items[2]}`])
   if(items[3]) classes.push(grid[`${cssClass}-lg-${items[3]}`])
   if(items[4]) classes.push(grid[`${cssClass}-xl-${items[4]}`])

   return [ ...interator, ...classes]
}

export const prefixClass = (items, cssClass, interator) => {
   items = items ? items.split(' ') : []
   let classes = []
   
   items.forEach(element => {
      classes.push(grid[`${cssClass}-${element}`])
   });

   return [ ...interator, ...classes]
}


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Grid/toCssClasses.js